import { useMemo } from 'react'

import { type ApplicationFrameProps } from '@factorialco/f0-react/dist/experimental'

export const useWelcomeScreenSuggestions = (): NonNullable<
  ApplicationFrameProps['ai']
>['welcomeScreenSuggestions'] => {
  return useMemo(() => {
    return []
  }, [])
}
